<template>
  <el-container>
    <div class="header">
      <div class="content clear-both">
        <div class="pull-left">
          <el-button class="collapse-btn"
                     type="text"
                     icon="sj-icon-category"
                     @click="COLLAPSE_MENU(!collapse)"></el-button>
        </div>
        <!--notification menu start -->
        <div class="pull-right">
          <el-dropdown trigger="click"
                       @command="handleCommand">
            <div class="el-dropdown-link">
              <i class="sj-icon-user-avatar"
                 style="font-size: 22px; margin-right: 5px;"></i>
              <span style="vertical-align: 3px;">
                <span>{{user.name}}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            </div>
            <el-dropdown-menu class="dropdown-menu"
                              slot="dropdown">
              <el-dropdown-item class="dropdown-menu__switch-item">
                <div class="dropdown-switch-item"
                     @click.stop="toggleAutoCollapseMenu">
                  <span>自动收起菜单</span>
                  <el-switch
                    :value="autoCollapseMenu"
                    @change="SET_AUTO_COLLAPSE_MENU"
                    @click.native.stop>
                  </el-switch>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="changePassword">
                <span class="sj-icon-change-passwd"> 修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <span class="sj-icon-logout"> 退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!--notification menu end -->
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      collapse: state => state.collapseMenu,
      autoCollapseMenu: state => state.autoCollapseMenu,
      user: state => state.login.user,
    }),
  },
  methods: {
    ...Vuex.mapMutations([
      'COLLAPSE_MENU',
      'SET_AUTO_COLLAPSE_MENU',
    ]),
    logout () {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        this.$store.commit('LOGOUT')
        this.$router.push(filter.loginPath(this.$route.fullPath))
      })
    },
    changePassword () {
      this.$router.push({path: '/settings/change-password'})
    },
    toggleAutoCollapseMenu () {
      this.SET_AUTO_COLLAPSE_MENU(!this.autoCollapseMenu)
    },
    handleCommand (command) {
      switch (command) {
        case 'logout':
          this.logout()
          break
        case 'changePassword':
          this.changePassword()
          break
      }
    },
  },
}
</script>

<style lang="scss">
.dropdown-menu {
  min-width: 120px;
  margin-top: 0px !important;
  border-top-width: 0px !important;
  -webkit-box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px !important;
  background-color: #424e62 !important;
  padding: 0px !important;

  .el-dropdown-menu__item {
    color: #bfcbd9;

    &:hover {
      background-color: #353f4f !important;
    }
  }

  .dropdown-menu__switch-item {
    padding: 0 !important;
    cursor: default;
  }

  .dropdown-switch-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 170px;
    padding: 0 16px;
    color: #bfcbd9;
    height: 34px;
    line-height: 34px;
  }

  .popper__arrow {
    border-color: transparent !important;

    &::after {
      border-bottom-color: #424e62 !important;
    }
  }
}
</style>

<style lang="scss"
       scoped>
.header {
  width: 100%;
  line-height: 50px;
  border-bottom: 1px solid #eff0f4;
  color: #606266;

  .content {
    padding-right: 20px;

    .collapse-btn {
      border-right: 1px solid #eff0f4;
      width: 50px;
      height: 50px;
      border-radius: 0px;
      font-size: 22px;

      &:hover {
        color: #fff;
        background-color: #409EFF;
        border-right-color: transparent;
      }
    }

    .el-dropdown {
      cursor: pointer;

      .el-dropdown-link {
        padding: 0 15px;
        height: 50px;
        position: relative;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/LayoutHeader.vue